import { getProvider } from '@/apollo'
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'

const NotificationModule = {
  namespaced: true,
  state: {
    notificationShown: false
  },
  getters: {
    notificationShown: (state) => {
      return state.notificationShown
    }
  },
  mutations: {
    showNotification: (state) => {
      state.notificationShown = true
    }
  },
  actions: {
    async customerNotifications ({ commit }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query customerNotifications {
          customerNotifications{
            notifications {
              webDetailsText
              webText
              id
            }
          }
        }`
      }).then((response) => {
        commit('showNotification')
        return response.data.customerNotifications
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
      })
    }
  }
}

export {
  NotificationModule
}
